import { createSlice } from '@reduxjs/toolkit';

const navigationSlice = createSlice({
  name: 'navigation',
  initialState: { previousRoute: '' },
  reducers: {
    setPreviousRoute(state, action) {
      state.previousRoute = action.payload;
    },
  },
});

export const { setPreviousRoute } = navigationSlice.actions;
export default navigationSlice;
